import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { useAlerts } from "../context";
import { BaseLayout } from "../components/Layouts/BaseLayout";
import { FluidSections } from "../components/FluidSections";

const Fluid = ({ data, pageContext, location }) => {
	/* Retrieve Page Data from the page query */
	const pageData = data.contentfulFluidLayout;
	const altLangPages = data.allSitePage;

	const { alertsCount } = useAlerts();

	/* Use the FluidSection component to build out the fluid page sections */
	return pageData.noLayout ? (
		<FluidSections data={pageData.pageSections} location={location} locale={pageContext.locale} />
	) : (
		<BaseLayout
			location={location}
			pageContext={pageContext}
			seo={pageData.seo}
			altLangPages={altLangPages}
			headerNavigation={pageData.headerNavigation}
			headerMenu={pageData.headerMenu}
			footerData={pageData.footer}
			alerts={alertsCount}
			pageType={pageData?.pageType}
			theme={pageData.theme}>
			{/* Pass the pageSections reference data to the FluidSections component */}
			<FluidSections data={pageData.pageSections} location={location} locale={pageContext.locale} />
		</BaseLayout>
	);
};

/* Declare page prop */
Fluid.propTypes = {
	data: PropTypes.object.isRequired,
	pageContext: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
};

export default Fluid;

/* Query page data using the pageSections GraphQL fragment included in the imported queryFluidSection file */
export const pageQuery = graphql`
	query GetFluidLayoutPageData($id: String!, $ctf_id: String!) {
		contentfulFluidLayout(id: { eq: $id }) {
			title
			pageType
			noLayout
			pageSections {
				...pageSections
			}
			seo {
				...seoComponent
			}
			headerNavigation {
				...headerNavigation
			}
			headerMenu {
				...headerMenu
			}
			footer {
				...footer
			}
			theme {
				...theme
			}
		}
		allSitePage(filter: { context: { ctf_id: { eq: $ctf_id } } }) {
			edges {
				...languageToggleButton
			}
		}
	}
`;
